import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../imageWithBasePath";
import { all_routes } from "../../../feature-module/router/all_routes";

const SidebarTwo = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* Sidenav Menu Start */}
      <div className="two-col-sidebar" id="two-col-sidebar">
        <div className="twocol-mini">
          {/* Add */}
          <div className="dropdown">
            <Link
              className="btn btn-primary bg-gradient btn-sm btn-icon rounded-circle d-flex align-items-center justify-content-center"
              data-bs-toggle="dropdown"
              to="#"
              role="button"
              data-bs-display="static"
              data-bs-reference="parent"
            >
              <i className="isax isax-add" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-start">
              <li>
                <Link
                  to={all_routes.addInvoice}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document-text-1 me-2" />
                  Invoice
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.expenses}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-money-send me-2" />
                  Expense
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addCreditNotes}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-money-add me-2" />
                  Credit Notes
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addDebitNotes}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-money-recive me-2" />
                  Debit Notes
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addPurchaseOrders}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document me-2" />
                  Purchase Order
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addquotations}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document-download me-2" />
                  Quotation
                </Link>
              </li>
              <li>
                <Link
                  to={all_routes.addDeliveryChallans}
                  className="dropdown-item d-flex align-items-center"
                >
                  <i className="isax isax-document-forward me-2" />
                  Delivery Challan
                </Link>
              </li>
            </ul>
          </div>
          {/* /Add */}
          <ul className="menu-list">
            <li>
              <Link
                to={all_routes.accountSettings}
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-title="Settings"
              >
                <i className="isax isax-setting-25" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-title="Documentation"
              >
                <i className="isax isax-document-normal4" />
              </Link>
            </li>
            <li>
              <Link
                to="#"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                data-bs-title="Changelog"
              >
                <i className="isax isax-cloud-change5" />
              </Link>
            </li>
            <li>
              <Link to={all_routes.login}>
                <i className="isax isax-login-15" />
              </Link>
            </li>
          </ul>
        </div>
        <div className="sidebar" id="sidebar-two">
          {/* Start Logo */}
          <div className="sidebar-logo">
            <Link to={all_routes.adminDashboard} className="logo logo-normal">
              <ImageWithBasePath src="assets/img/logo.svg" alt="Logo" />
            </Link>
            <Link to={all_routes.adminDashboard} className="logo-small">
              <ImageWithBasePath src="assets/img/logo-small.svg" alt="Logo" />
            </Link>
            <Link to={all_routes.adminDashboard} className="dark-logo">
              <ImageWithBasePath src="assets/img/logo-white.svg" alt="Logo" />
            </Link>
            <Link to={all_routes.adminDashboard} className="dark-small">
              <ImageWithBasePath src="assets/img/logo-small-white.svg" alt="Logo" />
            </Link>
            {/* Sidebar Hover Menu Toggle Button */}
            <Link id="toggle_btn" to="#">
              <i className="isax isax-menu-1" />
            </Link>
          </div>
          {/* End Logo */}
          {/* Search */}
          <div className="sidebar-search">
            <div className="input-icon-end position-relative">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
              />
              <span className="input-icon-addon">
                <i className="isax isax-search-normal" />
              </span>
            </div>
          </div>
          {/* /Search */}
          {/*- Sidenav Menu */}
          <div className="sidebar-inner" data-simplebar="">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li>
                  <ul>
                    <li className={isActive(all_routes.superAdminDashboard) ? "active" : ""}>
                      <Link to={all_routes.superAdminDashboard}>
                        <i className="isax isax-home-25 text-dark" />
                        <span>Dashboard</span>
                      </Link>
                    </li>
                    <li className={isActive(all_routes.companies) ? "active" : ""}>
                      <Link to={all_routes.companies}>
                        <i className="isax isax-buildings-25 text-dark" />
                        <span>Companies</span>
                      </Link>
                    </li>
                    <li className={isActive(all_routes.subscriptions) ? "active" : ""}>
                      <Link to={all_routes.subscriptions}>
                        <i className="isax isax-receipt-text5 text-dark" />
                        <span>Subscriptions</span>
                      </Link>
                    </li>
                    <li className={isActive(all_routes.packages) ? "active" : ""}>
                      <Link to={all_routes.packages}>
                        <i className="isax isax-layer5 text-dark" />
                        <span>Packages</span>
                      </Link>
                    </li>
                    <li className={isActive(all_routes.domain) ? "active" : ""}>
                      <Link to={all_routes.domain}>
                        <i className="isax isax-global5 text-dark" />
                        <span>Domain</span>
                      </Link>
                    </li>
                    <li className={isActive(all_routes.purchaseTransaction) ? "active" : ""}>
                      <Link to={all_routes.purchaseTransaction}>
                        <i className="isax isax-document-text5 text-dark" />
                        <span>Purchase Transaction</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
              <div className="sidebar-footer">
                <div className="trial-item bg-white text-center border">
                  <div className="bg-light p-3 text-center">
                    <ImageWithBasePath src="assets/img/icons/upgrade.svg" alt="img" />
                  </div>
                  <div className="p-2">
                    <h6 className="fs-14 fw-semibold mb-1">Upgrade to More</h6>
                    <p className="fs-13 mb-2">
                      Subscribe to get more with Premium Features
                    </p>
                    <Link
                      to={all_routes.plansBillings}
                      className="btn btn-sm btn-primary w-100 d-flex align-items-center justify-content-center"
                    >
                      <i className="isax isax-crown5 me-1" />
                      Upgrade
                    </Link>
                  </div>
                  <Link to="#" className="close-icon">
                    <i className="fa-solid fa-x" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Sidenav Menu End */}
    </>
  );
};

export default SidebarTwo;
